module.exports = __webpack_public_path__ + "overview-a5b6df21/encoding-c671d723d48853ff8aba29a41d9c1ba6.svg";